/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SearchCategory = {
    All: 'All',
    Companies: 'Companies',
    Orders: 'Orders',
    Invoices: 'Invoices'
} as const;
export type SearchCategory = typeof SearchCategory[keyof typeof SearchCategory];


export function instanceOfSearchCategory(value: any): boolean {
    for (const key in SearchCategory) {
        if (Object.prototype.hasOwnProperty.call(SearchCategory, key)) {
            if (SearchCategory[key as keyof typeof SearchCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SearchCategoryFromJSON(json: any): SearchCategory {
    return SearchCategoryFromJSONTyped(json, false);
}

export function SearchCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchCategory {
    return json as SearchCategory;
}

export function SearchCategoryToJSON(value?: SearchCategory | null): any {
    return value as any;
}

export function SearchCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): SearchCategory {
    return value as SearchCategory;
}

